import { defineTool } from '@/shell/tool';

/** Websites: Vibes' website builder in a frame (Flutter's `websites` embed). */
export default defineTool({
  id: 'vibes-websites',
  title: 'Websites',
  summary: "Vibes' website builder, in a frame.",
  section: 'vibes',
  order: 50,
  icon: 'language',
  owner: '@Drabu',
  permission: 'vibes-websites:use',
  routes: () => import('./WebsitesPage'),
});
